import { get } from 'jquery';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        member: null,
        activeNav: '',
        lang: '',
        exchangeSkin: 'night',
        loginTimes: null,
        logo: '',
        agentInfo: null,
        configList: {},
        usdtList: {},
    },
    mutations: {
        setusdtLit(state, usdtList) {
            state.usdtList = usdtList;
            localStorage.setItem('USDTLIST', JSON.stringify(usdtList));
        },
        initusdtLit(state) {
            if (localStorage.getItem('USDTLIST') == null) {
                state.usdtList = {
                    alias: "United States Dollar",
                    createTime: 1709721002000,
                    displaySymbol: "0024",
                    exchangeRate: 1,
                    status: 1,
                    unitCode: "USD",
                    updateTime: 1709721002000
                };
            } else {
                state.usdtList = JSON.parse(localStorage.getItem('USDTLIST'));
            }
        },
        setAgentInfo(state, data) {
            state.agentInfo = data
        },
        setLogo(state, data) {
            state.logo = data;
        },
        navigate(state, nav) {
            state.activeNav = nav;
        },
        setMember(state, member) {
            state.member = member;
            localStorage.setItem('MEMBER', JSON.stringify(member));
            if (member) {
                localStorage.setItem("TOKEN", member.token);
            } else {
                localStorage.setItem("TOKEN", '');
            }
        },
        recoveryMember(state) {
            state.member = JSON.parse(localStorage.getItem('MEMBER'));
        },
        setlang(state, lang) {
            state.lang = lang;
            localStorage.setItem('LANGUAGE', JSON.stringify(lang));
        },
        setconfigList(state, configList) {
            localStorage.setItem('APIVALUE', JSON.stringify(configList.defaultLanguages.apiValue));
            state.configList = configList;
        },

        initLang(state) {
            if (localStorage.getItem('LANGUAGE') == null) {
                state.lang = JSON.parse(localStorage.getItem('APIVALUE')) || 'en_US'
            } else {
                state.lang = JSON.parse(localStorage.getItem('LANGUAGE'));
            }
        },
        initLoginTimes(state) {
            if (localStorage.getItem("LOGINTIMES") == null) {
                state.loginTimes = 0;
            } else {
                state.loginTimes = JSON.parse(localStorage.getItem('LOGINTIMES'));
            }
        },
        setLoginTimes(state, times) {
            state.loginTimes = times;
            localStorage.setItem('LOGINTIMES', JSON.stringify(times));
        },
        setSkin(state, skin) {
            state.exchangeSkin = skin;
        }
    },
    getters: {
        agentInfo(state) {
            return state.agentInfo
        },
        logo(state) {
            return state.logo
        },
        member(state) {
            return state.member;
        },
        isLogin(state) {
            return state.member != null;
        },
        lang(state) {
            return state.lang;
        },
        loginTimes(state) {
            return state.loginTimes;
        },
        usdtList(state) {
            return state.usdtList;
        },
        configList(state) {
            return state.configList;
        },

    }
});



// WEBPACK FOOTER //
// ./src/store/store.js